import { ProjectItem } from "senac-components/dist/pages/Mobile/PageInterfaces";
import { AuthSSOParams, IUserService, ParamsSSO, User, UserRegisterData } from "./IUserService";
import Sdk from "api.digitalpages.module.sdk.api";
import { Profile } from "senac-components/dist/pages/Mobile/PageMyProfile";
import { ContactUsForm } from "senac-components/dist/pages/Mobile/PageContactUs";
import { cpfValidator } from "../../utilities/Cpf";
import { ERRORS } from "../../utilities/constants/errors";

export class UserServiceApi implements IUserService
{
    async AuthenticateSSOFromProvision(params: AuthSSOParams): Promise<User> {
         await Sdk.Api.authorization.signinProvisionSSO(params);

          const serverUser = await Sdk.Api.authorization.userInfo();

          return {
            uid : serverUser.uid,
            name : serverUser.detail.name,
            email: serverUser.detail.email_principal,
            cpf : serverUser.detail.cpf,
            phone: serverUser.detail.phone_principal,
            login: serverUser.login,
           } as User
      }

    CreatePassword = async (token: string, password: string): Promise<any> => {

        const result = await Sdk.Api.dynamic.bridge('/auth/v1.0/user/reset/password/token', { token, password }, "POST").then(res => res).catch(err => err)

        if(result?.message === 'Senha redefinida com sucesso!') return 200;

        return result.status;

    }

    checkExpiredDate = (date: string) => {
        try {
            const currentDate = new Date();
            const dateCompare = new Date(date);
            return dateCompare < currentDate;
        }
        catch(err) {
            return true;
        }
    }

    async AnonymousSignIn(project?: string): Promise<any> {
        const projectUid = project ?? Sdk.Api.authorization.activeProjectUid
        const currentAnonymous = (Sdk.Api.authorization as any).credentialAnonymous;
        await Sdk.Api.authorization.signinByProjectAnonymous(projectUid);
        if(!projectUid) return;

        if(!currentAnonymous || this.checkExpiredDate(currentAnonymous?.expiredDate))  {
            await Sdk.Api.authorization.signinByProjectAnonymous(projectUid);
        }
    }

    async SentContactUs(contact: ContactUsForm): Promise<ContactUsForm>
    {
        let sendData = {
            support : {
                user : {
                    name : contact.name,
                    email: contact.email,
                    phone: contact.telefone,
                },
                title: contact.assunto,
                message: contact.message
            }
        }

        const url = `auth/v1.1/directory/request/customers`;
        let serverUser = await Sdk.Api.dynamic.bridge(url, sendData, "POST");


        let data:ContactUsForm = {
            name : contact.name,
            email: contact.email,
            telefone: contact.telefone,
            assunto: contact.assunto,
            message: contact.message
        }

        return data;
    }


    async UpdatedProfile(profile: Profile): Promise<Profile> {

      const url = `auth/v1.0/user/me`;
      const formatedCpf = (profile.cpf ?? '').replaceAll('.', '').replace('-', '');
      const [first, last] = (profile.name ?? '').split(' ');

      let data = {
        login: formatedCpf,
        detail: {
          name : profile.name,
          email_principal: profile.email,
          phone_principal: profile.phone,
          cpf: formatedCpf,
          first_name: first ?? '',
          last_name: last ?? '',
        }
      }

    let serverUser = await Sdk.Api.dynamic.bridge(url, data, "PUT").catch((err) => {
        if (err.status === 400) {
            throw new Error(ERRORS.USER_UPDATING_ERROR_BECAUSE_CPF_ALREADY_REGISTERED);
        }
    })

    Sdk.Api.authorization.updateUserState(data)

    var result:User = {
        uid : serverUser.uid,
        name : serverUser.detail.name,
        email: serverUser.detail.email_principal,
        cpf : serverUser.detail.cpf,
        phone: serverUser.detail.phone_principal,
        login: serverUser.login,
    }

    return result;

}



    async ChangePassword(newPassword: string, currentPassword?: string): Promise<void> {

        const url = `auth/v1.0/user/reset/password`;

        let data = {
            password: newPassword,
            current_password: currentPassword
        }

        await Sdk.Api.dynamic.bridge(url, data, "POST");
    }


    async ProjectsAvailable(login: string): Promise<ProjectItem[]>
    {
        const url = `auth/v1.1/directory/user/login/projects/available?login=${encodeURIComponent(login)}&ignore_user_context=false`;
        const projects:any[] = await Sdk.Api.dynamic.bridge(url, null, "GET");
        const result = projects.map(p=>
        {
            var data:ProjectItem = {
                uid : p.uid,
                name : p.name
            }

            return data;
        })

        return result;
    }

    async ProjectsFromLogin(login: string) {
        const connector = this.getConnectorLibraryMigration();
        const url = `cms/v1.1/bridge/connector/uid/${connector}/available?login=${login}`;

        const result = await Sdk.Api.dynamic.bridge(url, null, 'POST');

        if (!result || !result.possible_accounts) {
            throw new Error('Nenhuma organização encontrada');
        }

        return {
            organizations: result.possible_accounts.map((item: any, index: number) => ({
                login: item.login,
                uid: item.organizationId ?? item.organization_id,
                name: item.organizationName ?? item.organization_name ?? `Organização ${index + 1}`,
                migrated: false,
            }))
        }
    }

    async SendForgotPasswordLibrary(params: { login: string; organization: string; }): Promise<any> {
        try {

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
        myHeaders.append("Ocp-Apim-Subscription-Key", "c748f0afd1834f188e87c33a3d8160c3");

        const raw = `user%5Bemail%5D=${params.login}&user%5Borganization_id%5D=${params.organization}`;
        // const successRawMock = `user%5Bemail%5D=paulo.inoue@digitalpages.com.br&user%5Borganization_id%5D=27`
        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
          };

        return await fetch("https://api.digitalpages.com.br/library/users/password.json", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.errors) {
                    throw new Error('Erro ao tentar realizar solicitação.')
                }

                return result;
            })
            .catch((error) => {
                throw new Error('Erro ao tentar realizar solicitação.')
            });
        }
        catch(err) {
            throw new Error('Erro ao tentar realizar solicitação.')
        }
    }
    async GetUserPreferences() {
        try {
            const preferences = await Sdk.Api.dynamic.bridge('auth/v1.0/user/me/preferences', null, "GET")
            return preferences;
        }
        catch(err) {
            console.log(err);
            return [];
        }
    };

    async GetProjects() {
        const result = await Sdk.Api.dynamic.bridge(`auth/v1.0/projects`, null, 'GET');
        return result || [];
    };

    async CretePreference(params = { key: "first_access", "value": Date.now() as any}) {
        const result = await Sdk.Api.dynamic.bridge(`auth/v1.0/user/me/preferences`, { ...params, "expire_at": null}, "POST")
        return result;
    }

    async GetUserLoginDetails() {
        try {
            const preferences = await this.GetUserPreferences();
            const firstLogin = (preferences || []).find((item: any) => item.key === 'first_access');
            if (!firstLogin) {
                this.CretePreference();
            }
            const projects = await this.GetProjects();

            return {
                projects,
                firstLogin: Boolean(firstLogin),
                preferences,
            }
        }
        catch(err) {
            return {} as any;
        }
    }

    async GetUserAuthFlow(result: any) {
        await Sdk.Api.authorization.signinByCredential(result);
        const preferences = await this.GetUserPreferences();
        const firstLogin = (preferences || []).find((item: any) => item.key === 'first_access');
        if (!firstLogin) {
            this.CretePreference();
        }
        const projects = await this.GetProjects();

        const serverUser = await Sdk.Api.authorization.userInfo();

        if (!serverUser) throw Error();

        var user: User = {
            uid : serverUser.uid,
            name : serverUser.detail.name,
            email: serverUser.detail.email_principal,
            cpf : serverUser.detail.cpf,
            phone: serverUser.detail.phone_principal,
            login: serverUser.login,
        }

        return {
            user,
            organizations: result.organizations ?? [],
            firstLogin: !Boolean(firstLogin),
            preferences,
            projects,
        };
    };

    async Authenticate(login: string, password: string, ignoreContext?: boolean): Promise<User>
    {
        try {
            await Sdk.Api.authorization.signinByLogin(login, password, ignoreContext);

            if (Sdk.Api.authorization.user) {
                const serverUser = await Sdk.Api.authorization.userInfo();
                var result:User = {
                    uid : serverUser.uid,
                    name : serverUser.detail.name,
                    email: serverUser.detail.email_principal,
                    cpf : serverUser.detail.cpf,
                    phone: serverUser.detail.phone_principal,
                    login: serverUser.login,
                }
                return result;
            }

            return null as any;
        }

        catch(err) {
            return null as any;
        }
    }

    async AuthenticateSSO({ login, organization, token }: ParamsSSO): Promise<any> {
        const connectorId = this.getConnectorLibraryMigration();

        if (!connectorId) {
            throw new Error('Ocorreu um erro de configuração');
        }

        const route = `/cms/v1.1/bridge/connector/uid/${connectorId}/sso?login=${login}&organization_id=${organization}&token=${token}`;

        const result = await Sdk.Api.dynamic.bridge(route, null, 'POST').catch(err => {
            throw new Error(err.status)
        })

        const userData = await this.GetUserAuthFlow(result);

        return userData
    }

    getConnectorLibraryMigration() {
        const connector = Sdk.Api.authorization.activeProject?.connectors?.find((item: any) =>
            (item.iternal_name === "LibraryMigration" || item.name === "SenacMigration"));

        const uid = connector?.uid;

        return uid;
    }

    async SigninDefault(login: string, password: string, ignoreContext?: boolean) {
        const userResult = await this.Authenticate(login, password, ignoreContext);
        if (userResult) {
            const details = await this.GetUserLoginDetails();
            return {
                user: userResult,
                ...(details || {}),
            }
        }
        else {
            throw new Error('Erro ao tentar efetuar autenticação');
        }
    }

    async SigninMigrationFlow(login: string, password: string, acessToken?: string, organization?: string): Promise<any> {
        if (!acessToken && !organization) {
            const userResult = await this.Authenticate(login, password);
            if (userResult) {
                const details = await this.GetUserLoginDetails();
                return {
                    user: userResult,
                    ...(details || {}),
                }
            }
        }

        const uid = this.getConnectorLibraryMigration();

        if (!uid) throw new Error('Senha inválida');

        let url = `cms/v1.1/bridge/connector/uid/${uid}/login?login=${login}&password=${password}`;

        if (acessToken && organization) {
            url = `${url}&organization_id=${organization}&access_token=${acessToken}`
        };

        const result = await Sdk.Api.dynamic.bridge(url, null, 'POST')
        .then((res) => {
            return {
                ...res,
                organizations: (res.possible_accounts ?? []).map((item: any, index: number) => ({
                    login: item.login,
                    uid: item.organizationId ?? item.organization_id,
                    name: item.organizationName ?? item.organization_name ?? `Organização ${index + 1}`,
                    migrated: false,
                }))
            }
        })
        .catch(err => {
            console.log(err)
        })
        if (result) {
            const data = await this.GetUserAuthFlow(result);
            return data;
        }

        if (!Sdk.Api.authorization.user) throw Error();

    };

    async SigninSsoAfterAuthentication({ login, password, organization, token, initialLogin, path }: any) {
        await this.SigninMigrationFlow(login, password);

        const user = await this.AuthenticateSSO({ login: initialLogin ?? login, organization, token, path })

        return user;
    }
    async SendOrganization(login: string, password: string, organization: string): Promise<any> {
        const auth = Sdk.Api.authorization?.credential?.accessToken;

        if (!auth) return false;

        const result = await this.SigninMigrationFlow(login, password, auth, organization);

        if (result) return result;

        return false;
    }

    async SendUniqueLogin(login: string): Promise<any> {

    };

    async SendCPFOrEmail(value: string): Promise<any> {

    };

    async ActiveUser(): Promise<User | undefined>
    {
        const serverUser = await Sdk.Api.authorization.user;
        if (!serverUser) return undefined;
        var result:User = {
            uid : serverUser.uid,
            name : serverUser.detail?.name,
            email: serverUser.detail?.email_principal,
            cpf : serverUser.detail?.cpf,
            phone: serverUser.detail?.phone_principal,
            login: serverUser.login,
        }

        console.log(result);
        return result;
    }

    async Logout(): Promise<void>
    {
        await Sdk.Api.authorization.logout();
    }

    async RecoverPassword(login:string): Promise<any>
    {
        var response = await Sdk.Api.dynamic.bridge(`/auth/v1.1/user/password/forgot?login=${encodeURIComponent(login)}`, {}, "POST");
        return response;
    }

    async CheckUniqueLogin (login: string) {
        await Sdk.Api.dynamic.bridge(`/auth/v1.1/user/login/check?login=${login}`, null, 'POST')
        .catch(() => {
            throw new Error("O CPF informado já está sendo utilizado na plataforma.")
        })
    };

    async RegisterUser (data: UserRegisterData) : Promise<User>
    {
        const validCPF = cpfValidator(data.cpf);

        if(!validCPF) throw new Error('O CPF informado é inválido! Não foi possível registrar o usuário.');

        await this.CheckUniqueLogin(data.cpf)

        var connector = Sdk.Api.authorization.activeProject.connectors
        .find((connector: any) =>
            connector.features?.find((f: string) => f === "IConnectorUserDirectRegister") !== undefined
        );

        const [first, last] = (data.name ?? '').split(' ');

        var serverUser = await Sdk.Api.dynamic.bridge(`/auth/v1.1/register/connector/uid/${connector.uid}/direct`, {
            login : data.cpf,
            password: data.password,
            detail : {
                email_principal : data.email,
                cpf: data.cpf,
                name: data.name,
                phone_principal: (data as any).phone,
                first_name: first ?? '',
                last_name: last ?? '',
            }
        }, 'POST');

        var result:User = {
            uid : serverUser.uid,
            name : serverUser.detail.name,
            email: serverUser.detail.email_principal,
            cpf : serverUser.detail.cpf,
            phone: serverUser.detail.phone_principal,
            login: serverUser.login,
        }

        return result;
    }
}